import styled from "styled-components";

export default styled.div`
  height: 1px;
  background-color: #9e9d9d;
  width: 100%;
  margin-top: 50px;
`;
